module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('order_status.title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('order_status.description')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.active_order.status != ''),
      expression: "active_order.status != ''"
    }]
  }, [_vm._v(_vm._s(_vm.active_order.status))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56d7434e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderStatus.vue
// module id = 260
// module chunks = 1